export type PersistedDashboardLotSelectionResolution =
  | { status: 'unchanged' }
  | { status: 'clear' }
  | { status: 'normalized'; lotId: string }

type ResolvePersistedDashboardLotSelectionArgs = {
  loadingData: boolean
  selectedLotId: string
  selectedProductionUnitId: string
  allProductionUnitsId: string
  normalizeLotSelection: (candidate: string, unitId: string) => string
}

export const resolvePersistedDashboardLotSelection = (
  args: ResolvePersistedDashboardLotSelectionArgs
): PersistedDashboardLotSelectionResolution => {
  if (args.loadingData) return { status: 'unchanged' }

  const selectedLotId = args.selectedLotId.trim()
  if (!selectedLotId) return { status: 'unchanged' }

  const selectedProductionUnitId = args.selectedProductionUnitId.trim()
  if (!selectedProductionUnitId || selectedProductionUnitId === args.allProductionUnitsId) {
    return { status: 'clear' }
  }

  const normalizedLotId = args.normalizeLotSelection(selectedLotId, selectedProductionUnitId)
  if (!normalizedLotId) {
    return { status: 'clear' }
  }

  if (normalizedLotId === selectedLotId) {
    return { status: 'unchanged' }
  }

  return { status: 'normalized', lotId: normalizedLotId }
}